import { useEffect, useState } from 'react';

const HIDDEN = 'hidden';

const getIsDocumentVisible = () => document.visibilityState !== HIDDEN;

export const useIsDocumentVisible = () => {
  const [isVisible, setIsVisible] = useState(getIsDocumentVisible);

  useEffect(() => {
    const onVisibilityChange = () => setIsVisible(getIsDocumentVisible());

    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  return isVisible;
};
